import React from "react";

// react-bootstrap components
import { Button, Card, Form, Container, Col } from "react-bootstrap";
import { apiService } from "../../service/ApiService";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

function LoginPage() {
  const history = useHistory();
  const { t } = useTranslation();
  const [username, setUsername] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [errorMessage, setErrorMessage] = React.useState("");

  const [cardClasses, setCardClasses] = React.useState("card-hidden");
  React.useEffect(() => {
    if (apiService.isTokenOk()) {
      if (apiService.isBackoffice()) {
        history.push("/admin/stores");
      } else {
        history.push("/admin/dashboard");
      }
      return;
    }
    localStorage.removeItem("token");
    localStorage.removeItem("id");
    localStorage.removeItem("username");
    localStorage.removeItem("accessLevel");
    setTimeout(function () {
      setCardClasses("");
    }, 1000);
  });

  const onLoginClick = (e) => {
    e.preventDefault();
    apiService
      .login(username, password)
      .then(() => {
        if (apiService.isBackoffice()) {
          history.push("/admin/stores");
        } else {
          history.push("/admin/dashboard");
        }
      })
      .catch((error) => {
        setErrorMessage(error.message);
      });
  };

  return (
    <>
      <div className="full-page section-image" data-color="black" data-image={require("assets/img/login-background.jpg")}>
        <div className="content d-flex align-items-center p-0">
          <Container>
            <Col className="mx-auto" lg="4" md="8">
              <Form action="" className="form" method="">
                <Card className={"card-login " + cardClasses}>
                  <Card.Header>
                    <h3 className="header text-center">{t("auth.login.title")}</h3>
                  </Card.Header>
                  <Card.Body>
                    <Card.Body>
                      {errorMessage ? <p style={{ color: "crimson" }}>{errorMessage}</p> : null}
                      <Form.Group>
                        <label>{t("auth.login.usernameLabel")}</label>
                        <Form.Control
                          placeholder={t("auth.login.usernamePlaceholder")}
                          type="text"
                          value={username}
                          onChange={(e) => setUsername(e.target.value)}
                        ></Form.Control>
                      </Form.Group>
                      <Form.Group>
                        <label>{t("auth.login.passwordLabel")}</label>
                        <Form.Control
                          placeholder={t("auth.login.passwordPlaceholder")}
                          type="password"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Card.Body>
                  </Card.Body>
                  <Card.Footer className="ml-auto mr-auto">
                    <Button className="btn-wd" type="submit" variant="warning" onClick={(e) => onLoginClick(e)}>
                      {t("auth.login.submit")}
                    </Button>
                  </Card.Footer>
                </Card>
              </Form>
            </Col>
          </Container>
        </div>
        <div
          className="full-page-background"
          style={{
            backgroundImage: "url(" + require("assets/img/login-background.jpg") + ")",
          }}
        ></div>
      </div>
    </>
  );
}

export default LoginPage;
